import { Box, Link, Typography } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import { Link as RouterLink } from 'react-router'

import style from './style'
import { useLanguage } from '../../LanguageContext'
import Service from '../../components/Service'

const Services = () => {
  const intl = useIntl()
  const language = useLanguage()

  return (
    <Box sx={style.container}>
      <Box sx={style.titleContainer}>
        <Typography variant="h1" fontSize={48} color="secondary">
          <FormattedMessage id="Services.Title" defaultMessage="Services" />
        </Typography>
      </Box>

      <Box sx={style.serviceContainer}>
        <Service
          imgSrc="/images/wine-cellar.png"
          title={intl.formatMessage({
            id: 'Services.Cellar.Title',
            defaultMessage: 'Wine cellar Optimization',
          })}
          content={intl.formatMessage({
            id: 'Services.Cellar.Content',
            defaultMessage:
              'Whether you want to build up a customized wine cellar or if you need help to sort out which wines you have in your cellar and how to maximize the experience with those wines, we can help you.',
          })}
        />

        <Service
          imgSrc="/images/wine-pairing.jpeg"
          title={intl.formatMessage({
            id: 'Services.Pairing.Title',
            defaultMessage: 'Wine pairing advice',
          })}
          content={intl.formatMessage({
            id: 'Services.Pairing.Content',
            defaultMessage:
              'If you need advice on pairing and sourcing wines for a specific dinner or occasion, we can help you. Tell us about your dinner plans, number of guests and we will advise you on the wine selection, its pairing with food and its optimal service(temperature, optimal timing for opening...).We may even source the wine for you if needed.',
          })}
        />

        <Service
          imgSrc="/images/grapes.png"
          title={intl.formatMessage({
            id: 'Services.Importation.Title',
            defaultMessage: 'Importation of wines & advice',
          })}
          content={intl.formatMessage(
            {
              id: 'Services.Importation.Content',
              defaultMessage:
                'Juliette is sourcing small wine producers making high quality wines, not easily accessible in Switzerland. Those producers take great care of the environment and of not adding too many sulfites into their wines.{br}{br}Furthermore, all the selected wines are ready to drink, and don’t need to be aged in a cellar. Juliette will also provide you with advice on how to serve those wines (temperature, optimal timing for opening...), suggestions of food pairing and occasions for each wine.{br}{br}If you want to know more about our selected wines, you may want to check {link}.',
            },
            {
              br: <br />,
              link: (
                <Link component={RouterLink} to={`/${language}/wine-selection`}>
                  <FormattedMessage
                    id="Service.Importation.WineSelectionLink"
                    defaultMessage="our wine selection page"
                  />
                </Link>
              ),
            }
          )}
        />
      </Box>
    </Box>
  )
}

export default Services
